import { observer } from "mobx-react"
import { useState, useEffect, useRef } from "react"
import { Button } from "@mui/material"
import Image from "../Common/Image/Image"
import AppStore from "../../Configs/Stores/AppStore"
import Step1 from "../../assets/HowItWorks/Step1.svg"
import Step2 from "../../assets/HowItWorks/Step2.svg"
import Step3 from "../../assets/HowItWorks/Step3.svg"
import Step4 from "../../assets/HowItWorks/Step4.svg"
import Step1_icon from "../../assets/HowItWorks/Step1_icon.svg"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import { GrabToHScroll } from "../Common/CommonFunctions"
import styles from "./HowItWorks.module.css"
import useOnScreen from "../Common/useOnScreen"
import CardJsonData from "./HowItWorks.json"

const ImageGroup: string[] = [Step1, Step2, Step3, Step4, Step1_icon]
type CardDetails = {
  id: number
  content: string
}


const HowItWorks = observer(() => {
  const [selectedItem, setSelectedItem] = useState<number>(0)
  const [isMouseDragging, setIsMouseDragging] = useState<boolean>(false)

  const HowItWorksConRef = useRef<any>(null)
  const isSectionVisible = useOnScreen(HowItWorksConRef, "50px")
  const CardData: Array<CardDetails> = CardJsonData

  useEffect(() => {
    if (AppStore.device === 0) {
      setTimeout(GrabToHScroll, 250, "HowItWorksCardScroll")
    }
  }, [AppStore.device])

  const onChangeItem = () => {
    if (isSectionVisible && AppStore.device === 0) {
      const element = selectedItem <= 1 ? -window.innerWidth : (window.innerWidth / CardData.length) * selectedItem
      HowItWorksConRef.current.scrollBy({ behavior: "smooth", left: element })
      console.info("Event onChangeItem :", selectedItem, element)
    }
  }

  const onSwipeCarouselStart = (e: any) => {
    setIsMouseDragging(true)
    console.info("Event onSwipeCarouselStart :", e)
  }

  const onSwipeCarouselEnd = (e: any) => {
    setIsMouseDragging(false)
    console.info("Event onSwipeCarouselEnd :", e)
  }

  return (
    <section className={styles.HowItWorksClass}>
      <div className={styles.HowItWorksMainContainer}>
        <h2 className={styles.HowItWorksTitle}>
          How Does ICICI Life Child Education Planner Works?
        </h2>
        <div className={styles.BenefitMainContaint}>
          <div ref={HowItWorksConRef} className={`${styles.HowItWorksContainer} HowItWorksCardScroll`}>
            {CardData.map((cardinfo: CardDetails, index: number) => (
              <Button
                key={"WhyHowItWorks_LeftCont_" + index}
                className={`${styles.WrappingContainer} ${selectedItem === cardinfo.id - 1 ? styles.Selected : styles.Default}`}
                // data-title={cardinfo.content}
                onClick={() => {
                  setSelectedItem(cardinfo.id - 1)
                }}
              >{cardinfo.content }
              </Button>
            ))}
          </div>
        </div>
        <div className={styles.HowItWorksCarouselParent}>
        <div className={styles.HowItWorksCarouselWrapper}>
          {/* <span className={styles.BenefitContaint}>The child education calculator works by taking your inputs such as: </span> */}
          <Carousel
          className={`${styles.HowItWorksCarouselContainer} ${isMouseDragging ? "Grabbing" : "Grab"}`}
          selectedItem={selectedItem}
          infiniteLoop
          emulateTouch={true}
          // autoPlay={true}
          showStatus={false}
          showThumbs={false}
          showArrows={false}
          showIndicators={false}
          onSwipeStart={onSwipeCarouselStart}
          onSwipeEnd={onSwipeCarouselEnd}
          onChange={(current) => {
            setSelectedItem(current)
            onChangeItem()
          }}
          interval={7000}
        >
         <div className={`${styles.HowItWorksCarouselBox}`}>
              <div className={styles.HowItWorksImage_mobile}>
                <Image src={ImageGroup[4]} alt="check" lazy width={`36px`} height={`36px`} />
              </div>
              <h3 className={`${styles.HowItWorksCarouselHeading}`}>The child education calculator works by taking inputs such as:</h3>
              <div className={`${styles.HowItWorksCarouselContentWrapper}`} >
                <div className={styles.HowItWorksCarouselContent}>
                  <div className={styles.HowItWorksCarouselContentImage}>
                    <Image src={ImageGroup[0]} alt="check" lazy width={`28px`} height={`28px`} />
                  </div>
                <div className={styles.HowItWorksCarouselContentText}>
                  Parent's date of birth
                </div>
              </div>
              <div className={styles.HowItWorksCarouselContent}>
                <div className={styles.HowItWorksCarouselContentImage}>
                  <Image src={ImageGroup[0]} alt="check" lazy width={`28px`} height={`28px`} />
                </div>
                <div className={styles.HowItWorksCarouselContentText}>
                  Parent's gender
                </div>
              </div>
              <div className={styles.HowItWorksCarouselContent}>
                <div className={styles.HowItWorksCarouselContentImage}>
                  <Image src={ImageGroup[0]} alt="check" lazy width={`28px`} height={`28px`} />
                </div>
                <div className={styles.HowItWorksCarouselContentText}>
                  Child's name
                </div>
              </div>
              <div className={styles.HowItWorksCarouselContent}>
                <div className={styles.HowItWorksCarouselContentImage}>
                  <Image src={ImageGroup[0]} alt="check" lazy width={`28px`} height={`28px`} />
                </div>
                <div className={styles.HowItWorksCarouselContentText}>
                  Child's gender
                </div>
              </div>
              <div className={styles.HowItWorksCarouselContent}>
                <div className={styles.HowItWorksCarouselContentImage}>
                  <Image src={ImageGroup[0]} alt="check" lazy width={`28px`} height={`28px`} />
                </div>
                <div className={styles.HowItWorksCarouselContentText}>
                  Child's date of birth
                </div>
              </div>
                </div>
            </div>

            <div className={`${styles.HowItWorksCarouselBox2}`}>
              <div className={styles.HowItWorksImage2}>
                <Image src={ImageGroup[1]} alt="check" lazy width={`36px`} height={`36px`} />
              </div>
              <div className={styles.HowItWorksCarouselContent2}>
                It then factors in the career or profession your child aims to pursue and the age at which they will need the funds. Based on these details, the calculator shows you the current average cost of education for that profession and how education inflation will impact this cost over time.
              </div>
            </div>

            <div className={`${styles.HowItWorksCarouselBox2}`}>
              <div className={styles.HowItWorksImage2}>
                <Image src={ImageGroup[2]} alt="check" lazy width={`36px`} height={`36px`} />
              </div>
              <div className={styles.HowItWorksCarouselContent2}>
                Once you know the future savings estimate for your child's education needs, you can plan efficiently.
              </div>
            </div>

            <div className={`${styles.HowItWorksCarouselBox2}`}>
              <div className={styles.HowItWorksImage2}>
                <Image src={ImageGroup[3]} alt="check" lazy width={`36px`} height={`36px`} />
              </div>
              <div className={styles.HowItWorksCarouselContent2}>
                The calculator also offers insights on how much you need to invest monthly, half-yearly or annually and for how long to achieve your goal.
              </div>
            </div>
        </Carousel>
        </div>    
        </div>      
      </div>
    </section>
  )
})

export default HowItWorks
